/**
 * src/utils/imageCompressor.js
 * فشرده‌سازی و تغییر سایز خودکار تصویر با Canvas مرورگر
 */
export const compressImage = async (
  file,
  maxSizeMB = 1,
  maxWidthOrHeight = 1920,
) => {
  // اگر فایل تصویر نبود یا از ابتدا زیر ۱ مگابایت بود، دست نزن
  if (
    !file ||
    !file.type.startsWith("image/") ||
    file.size <= maxSizeMB * 1024 * 1024
  ) {
    return file;
  }

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        // تغییر مقیاس هوشمند متناسب با طول و عرض
        if (width > height) {
          if (width > maxWidthOrHeight) {
            height = Math.round((height * maxWidthOrHeight) / width);
            width = maxWidthOrHeight;
          }
        } else {
          if (height > maxWidthOrHeight) {
            width = Math.round((width * maxWidthOrHeight) / height);
            height = maxWidthOrHeight;
          }
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        // عکس‌های بزرگ گوشی رو به JPEG با کیفیت مناسب تبدیل می‌کنیم تا فوق‌العاده سبک بشه
        const targetMime =
          file.type === "image/png" ? "image/png" : "image/jpeg";

        const toBlobRecursive = (q) => {
          canvas.toBlob(
            (blob) => {
              if (!blob) {
                resolve(file);
                return;
              }

              // اگر با کیفیت انتخابی هنوز بالای ۱ مگابایت بود، یک پله کیفیت رو کم کن
              if (blob.size > maxSizeMB * 1024 * 1024 && q > 0.45) {
                toBlobRecursive(q - 0.15);
              } else {
                const extension = targetMime === "image/png" ? ".png" : ".jpg";
                const newName = file.name.replace(/\.[^/.]+$/, extension);
                const compressedFile = new File([blob], newName, {
                  type: targetMime,
                  lastModified: Date.now(),
                });
                resolve(compressedFile);
              }
            },
            targetMime,
            q,
          );
        };

        toBlobRecursive(0.82);
      };

      img.onerror = () => resolve(file);
    };

    reader.onerror = () => resolve(file);
  });
};
